import ApiService from '../../services/apiService';
import { mergeTrees, userItemsPerListMixin } from '../../utils/vuex';
import { mapState, mapGetters } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
const defaultItemsPerPage = 10;
const defaultTableOptions = {
  sortBy: ['id'],
  sortDesc: [false],
  page: 1,
  itemsPerPage: defaultItemsPerPage
};
export default {
  name: 'ViewAccountMgmtAccountMgmtRoleEditor',
  mixins: [userItemsPerListMixin],
  data: function () {
    return {
      showDialogRoleWizardDelete: false,
      confirmRoleWizardDeleteId: null,
      tenants: [],
      activeTenants: [],
      selectedTenant: null,
      roleEditorStepIndex: 1,
      tabItem: null,
      treeSearch: null,
      buttons01: [],
      rolesForScope: [],
      roleList: [],
      ruleList: [],
      roleEditItem: null,
      roleAddDialog: false,
      expandedRows: [],
      tableOptions: {
        ...defaultTableOptions
      },
      serverItemsLength: null
    };
  },
  computed: {
    ...mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color', 'UiTheme', 'permissions']),
    ...mapGetters({
      sessionUserId: 'authentication/userId'
    }),
    buttonsRoleList() {
      return [{
        icon: 'fal fa-plus',
        action: 'openRoleAddDialog',
        valid: this.activeTenants.length > 0,
        title: this.$i18n_t('Common.create'),
        tooltip: this.$i18n_t('Common.create')
      }];
    },
    tableLocalizations() {
      return {
        headers: [{
          sortable: false,
          text: this.$i18n_t('accMgmt.tenant.roleIcon'),
          value: null,
          width: '30px'
        }, {
          sortable: true,
          text: 'ID',
          value: 'id'
        }, {
          sortable: true,
          text: this.$i18n_t('accMgmt.tenant.roleName'),
          value: 'name'
        }, {
          sortable: false,
          text: this.$i18n_t('accMgmt.tenant.roleDescription'),
          value: 'description'
        }, {
          sortable: false,
          text: this.$i18n_t('accMgmt.tenant.permissions'),
          value: null
        }, {
          sortable: false,
          text: this.$i18n_t('Common.actions'),
          value: '',
          align: 'right'
        }],
        tableFooterProps: {
          itemsPerPageText: this.$i18n_t('Common.rowsPerPage'),
          itemsPerPageOptions: [10, defaultItemsPerPage, 20, 50]
        }
      };
    }
  },
  watch: {
    dialog(val) {
      val || this.close();
    },
    selectedTenant() {
      this.fetchRules();
    }
  },
  mounted() {
    this.checkAccess();
    this.tableOptions.itemsPerPage = this.savedUserItemsPerList();
  },
  methods: {
    openRoleAddDialog() {
      this.roleEditItem = {
        properties: {}
      };
      this.roleAddDialog = true;
    },
    openRoleEditDialog(item) {
      this.roleEditItem = cloneDeep(item);
      if (!this.roleEditItem.properties) {
        this.roleEditItem.properties = {};
      }
      this.roleAddDialog = true;
    },
    saveTab01() {
      this.$refs.accessSelector.handleSubmit();
    },
    closeTab01() {
      this.$refs.accessSelector.close();
    },
    checkAccess() {
      if (this.permissions['all.manage']) {
        this.fetchRules();
        this.fetchTenant();
      }
    },
    fetchTenant() {
      // NOTE: do not use 'authentication/primaryTenantIds' here, since those are not guaranteed to be
      // `all.manage` accounts. Instead, the `all.manage.tenantIds` is an already filtered list of tenantIds,
      // of which the user has all.manage on tenant-scope level
      return Promise.all(this.permissions['all.manage.tenantIds'].map(tenantId => {
        return ApiService.tenantGetById(tenantId, ['no-scope-descendents']);
      })).then(tenants => {
        tenants.forEach(tenant => {
          if (!tenant.data) {
            tenant.data = {};
          }
        });
        if (!this.selectedTenant && tenants.length > 0) {
          this.selectedTenant = tenants[0];
        }
        this.tenants = mergeTrees(tenants);
        this.fetchRoles();
      }).catch(error => {
        if (error.response && this.$i18n_t(`Error.${error.response.data.message}`)) {
          this.$snack(this.$i18n_t(`Error.${error.response.data.message}`), 'error');
        } else {
          this.$snack(this.$i18n_t('Common.tenantReadFail'), 'error');
        }
      }).finally(() => {
        this.$store.state.app.loading = false;
      });
    },
    fetchRoles() {
      ApiService.fetchRoles(this.selectedTenant.scopeId, null, true).then(roles => {
        this.roleList = roles;
        this.serverItemsLength = roles.length;
      }).catch(error => {
        console.error(error);
      });
    },
    confirmDeleteRole(id) {
      this.showDialogRoleWizardDelete = true;
      this.confirmRoleWizardDeleteId = id;
    },
    deleteRole(id) {
      this.confirmRoleWizardDeleteId = null;
      ApiService.deleteRole(id).then(() => {
        this.fetchRoles();
      }).catch(error => {
        console.error(error);
      });
    },
    fetchRules() {
      if (!this.selectedTenant) {
        return;
      }
      ApiService.fetchRulesByTenant(this.selectedTenant.id).then(rules => {
        rules.sort((a, b) => {
          return a.name.toLowerCase() < b.name.toLowerCase() ? -1 : 1;
        });
        this.ruleList = rules;
      }).catch(error => {
        console.error(error);
      });
    },
    changedSelectedTenant(tenantIds) {
      if (!tenantIds.length || !this.tenants || !this.tenants.length) {
        return;
      }
      this.selectedTenant = this.findTenantInTreeArray(this.tenants, tenantIds[0]);
      this.roleEditorStepIndex = 2;
      this.fetchRoles();
    },
    findTenantInTreeArray(treeArray, tenantId) {
      for (let i = 0; i < treeArray.length; i++) {
        const foundTenant = this.findTenantInTree(treeArray[i], tenantId);
        if (foundTenant) {
          return foundTenant;
        }
      }
      return null;
    },
    findTenantInTree(tree, tenantId) {
      if (tree.id === tenantId) {
        return tree;
      }
      if (tree.children && tree.children.length > 0) {
        return this.findTenantInTreeArray(tree.children, tenantId);
      }
      return null;
    },
    tenantTreeIcon(tenant) {
      return !tenant.parentId ? 'fal fa-users' : !tenant.children || tenant.children.length === 0 ? 'fal fa-user' : 'fal fa-user-friends';
    },
    refreshRoles() {
      this.$snack(this.$i18n_t('Common.userUpdated'), 'success');
      this.expandedRows = [];
      this.roleAddDialog = false;
      this.fetchRoles();
    },
    fetchDefaultRolesForScope(scopeId) {
      ApiService.fetchDefaultRoles(scopeId, true).then(roles => {
        this.rolesForScope = roles.sort((a, b) => {
          return a.name.localeCompare(b.name);
        });
      }).catch(error => {
        console.error(error);
      });
    },
    processDefaultRoles(roles, scopeId) {
      ApiService.updateDefaultRoles(scopeId, roles.map(role => role.id)).then(() => {
        this.$snack(this.$i18n_t('Common.userUpdated'), 'success');
      }).catch(error => {
        if (error.response && this.$i18n_t(`Error.${error.response.data.message}`)) {
          this.$snack(this.$i18n_t(`Error.${error.response.data.message}`), 'error');
        } else {
          this.$snack(this.$i18n_t('Common.oops1'), 'error');
        }
      });
    },
    setCurrentTablePage(value) {
      this.tableOptions.page = value;
    }
  }
};